<!--
 * @Description: 
-->
<!--
 * @Description: 
-->
<template>
	<div id="app">
		<router-view v-if="isRresh"/>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isRresh: true
		};
	},
	destroyed() {
		// 移除监听
		// window.removeEventListener("beforeunload", this.beforeunloadHandler);
	},
	mounted() {
		// 监听浏览器关闭
		// window.addEventListener("beforeunload", this.beforeunloadHandler);
	},
	provide() {
		return {
			refresh: this.refresh,
		};
	},
	methods: {
		refresh() {
			this.isRresh = false;
			this.$nextTick(() => {
				this.isRresh = true;
			});
		},
		// 关闭窗口之前执行
		// beforeunloadHandler(event) {
		// 	this._post(this.API.userLogout + `?mobile=${this.$store.state.userinfo.mobile}`).then((res) => {
		// 		console.log(res);
		// 		if (res.code === 200) {
		// 			localStorage.setItem("focusNo", 0);
		// 			this.$router.push({ name: item.href });
		// 			this.$store.dispatch("loginSuccess", null);
		// 			// this.isShowLogin = true
		// 		} else {
		// 			this.$Message.error(res.msg);
		// 		}
		// 		event.preventDefault();
		// 		event.returnValue = "";
		// 	});
		// },
	},
};
</script>
<style>
#app {
	padding: 0;
	margin: 0;
}
</style>
